import $ from 'jquery';
import L from 'leaflet';

export default {
  init() {
  
  },
  finalize() {
    //console.log('bla');
    console.log(locations_array);
    var map = L.map('locations-map-container').setView([50.941278, 6.958281], 13);

    
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    /*var Stadia_AlidadeSmooth = L.tileLayer('https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}{r}.png', {
      maxZoom: 20,
      attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
    });
    Stadia_AlidadeSmooth.addTo(map);*/
    
    var redIcon = L.icon({
      iconUrl: '/wp-content/themes/jazz2025/src/img/map-icon.png',  
      iconSize:     [30, 30], // size of the icon
      iconAnchor:   [0, 0], // point of the icon which will correspond to marker's location
      popupAnchor:  [16, 4] // point from which the popup should open relative to the iconAnchor
    });

    for(let location of locations_array){
      var marker = L.marker([location["lat"], location["long"]], {
          icon: redIcon,
          riseOnHover: true,
      }).addTo(map);
      marker.bindPopup(location["title"]).openPopup();
    }
  },
};
